import { Component, OnInit, Input, ViewContainerRef, Output, EventEmitter } from '@angular/core';
import { ItineraryService } from '../../itinerary.service';
import { DatePipe } from '@angular/common';
import { isValidOwener } from '../../../utils/Functions';
import { CookieService } from 'ngx-cookie';
import { UserService } from 'app/pages/com.usblick.common/auth/user.service';
import * as moment from 'moment';
import { TransportsService } from './transports.service';
@Component({
  selector: 'usb-modal-transports',
  templateUrl: './modal-transports.component.html',
  styleUrls: ['./modal-transports.component.scss'],
  providers: [DatePipe]
})

export class ModalTransportsComponent implements OnInit {

  @Input() productQty: number;
  @Input() product: any;
  @Input() service: any;
  @Input() result: any;
  @Input() form: any;
  @Input() payload?: any;
  @Input() payloadUpdate?: any;
  @Input() itineraryItem?: any;
  @Input() origin?: any;
  @Input() arrayResults?: any;
  @Input() _item?: any;
  @Input() view_info: any;
  @Input() fliyingInfo: any;
  @Input() formTransport: any;
  @Input() clientSetting: any;
  @Input() currencies: any[] = [];
  @Input() currencyAgency: any;
  @Input() tabActive:any;
  @Input() paymentAgencyActive: any;
  @Input() vehicles: any[] = [];
  @Input() quote: boolean = true;
  @Input() action: string = '';
  @Input() from: string = '';
  @Output() refModal = new EventEmitter<any>();


  disableButton = false;
  max: number;
  rate = 4;
  ratereview = 4.5;
  isReadonly: boolean;
  x = 5;
  y = 2;
  select: any[] = [];
  totalQty = 0;
  single: any[];
  view: any[] = [200, 150];
  categories = [];
  price: any;
  // options
  rates = [];
  ticketsPrice: any;
  days = [];
  daysArray = [];
  ticketResult: any;
  ticket: any;
  _days: any;
  mealResult: any;
  _rated: any;
  showXAxis = true;
  showYAxis = true;
  gradient = false;
  showLegend = false;
  showXAxisLabel = false;
  xAxisLabel = '.';
  showYAxisLabel = true;
  item: any;
  yAxisLabel = '%';
  selected: any;
  _resultsQuery: any;
  currencySelected: string;
  colorScheme = {
    domain: ['#00a680', '#00a680', '#00a680', '#00a680', '#00a680']
  };
  selectedOneVehicleDoubleWay: boolean = false;

  public options = {
    position: ['top', 'right'],
    timeOut: 460,
    lastOnBottom: true,
    showProgressBar: false,
    pauseOnHover: false,
    clickToClose: true,
    maxLength: 60
  };


  constructor(
    public vcr: ViewContainerRef,
    private _itineraryService: ItineraryService,
    private _userService: UserService,
    private _cookieService: CookieService,
    private transportService: TransportsService) {}


  ngOnInit() {
    // ============================================================
    // DEBUG: dump everything this modal needs to work.
    // Open the browser console and trigger this modal to see the
    // full picture of inputs + localStorage state + service state.
    // Safe to remove once the modal is verified working in the
    // target flow.
    // ============================================================
    console.groupCollapsed(
      `%c[modal-transports]%c inputs @ ${new Date().toISOString()}`,
      'background:#00ffb4;color:#000;font-weight:bold;padding:2px 6px;border-radius:3px',
      'color:inherit'
    );

    // 1. Every @Input declared in the component
    const inputsSnapshot: Record<string, any> = {
      productQty: this.productQty,
      product: this.product,
      service: this.service,
      result: this.result,
      form: this.form,
      payload: this.payload,
      payloadUpdate: this.payloadUpdate,
      itineraryItem: this.itineraryItem,
      origin: this.origin,
      arrayResults: this.arrayResults,
      _item: this._item,
      view_info: this.view_info,
      fliyingInfo: this.fliyingInfo,
      formTransport: this.formTransport,
      clientSetting: this.clientSetting,
      currencyAgency: this.currencyAgency,
      currencies: this.currencies,
      tabActive: this.tabActive,
      paymentAgencyActive: this.paymentAgencyActive,
      vehicles: this.vehicles,
      quote: this.quote,
      action: this.action,
      from: this.from,
    };
    console.log('1) @Input snapshot (undefined = parent did NOT pass it):');
    const inputRows: Record<string, string> = {};
    Object.keys(inputsSnapshot).forEach((k) => {
      const v = (inputsSnapshot as any)[k];
      inputRows[k] =
        v === undefined
          ? '❌ undefined'
          : v === null
          ? '⚠️ null'
          : Array.isArray(v)
          ? `array[${v.length}]`
          : typeof v === 'object'
          ? `object{${Object.keys(v).length} keys}`
          : `${typeof v}: ${String(v).slice(0, 60)}`;
    });
    console.table(inputRows);

    // 2. localStorage keys this modal reads from
    const lsKeys = ['payload', 'transport_assignment', 'returnTransferPayload', 'returnTransferForm'];
    console.log('2) localStorage state (parsed JSON, or raw if parse fails):');
    lsKeys.forEach((key) => {
      const raw = localStorage.getItem(key);
      if (raw === null) {
        console.log(`   ${key}: ❌ NOT SET`);
        return;
      }
      try {
        const parsed = JSON.parse(raw);
        if (Array.isArray(parsed)) {
          console.log(`   ${key}: ✅ array[${parsed.length}]`, parsed[0] ?? '(empty)');
        } else if (parsed && typeof parsed === 'object') {
          console.log(`   ${key}: ✅ object{${Object.keys(parsed).join(', ')}}`, parsed);
        } else {
          console.log(`   ${key}: ✅ scalar`, parsed);
        }
      } catch (e) {
        console.log(`   ${key}: ⚠️ NOT JSON, raw=`, raw.slice(0, 200));
      }
    });

    // 3. Services this modal will use at runtime
    console.log('3) Services snapshot:');
    const transportAssignment = this.transportService.getCurrentAssignment();
    console.log('   transport_assignment (TransportsService):', transportAssignment ?? '❌ not initialised');
    console.log('   itineraryArrivalDateFull (UserService):', this._userService?.itineraryArrivalDateFull);
    console.log('   itineraryDepartureDateFull (UserService):', this._userService?.itineraryDepartureDateFull);
    console.log('   numberNoCloneOneWay (UserService):', this._userService?.numberNoCloneOneWay);
    console.log('   _agencyID (UserService):', this._userService?._agencyID);
    console.log('   _agentID (UserService):', this._userService?._agentID);
    console.log('   clientId (ItineraryService.itinerary):', this._itineraryService?.itinerary?.clientId);

    // 4. Cross-checks — flag the inputs that the modal CANNOT work without
    console.log('4) Critical-input check:');
    const criticals: Array<[string, any]> = [
      ['service (vehicle to add)', inputsSnapshot.service],
      ['payload (localStorage OR @Input)', inputsSnapshot.payload ?? this._tryReadLs('payload')],
      ['transport_assignment', this._tryReadLs('transport_assignment')],
      ['clientSetting (owner / agency id)', inputsSnapshot.clientSetting],
      ['vehicles (array of selectable options)', inputsSnapshot.vehicles],
      ['form (search form: origin, arrivalDate, ...)', inputsSnapshot.form],
    ];
    criticals.forEach(([name, val]) => {
      if (val === undefined || val === null) {
        console.warn(`   ❌ MISSING: ${name}`);
      } else if (Array.isArray(val) && val.length === 0) {
        console.warn(`   ⚠️ EMPTY ARRAY: ${name}`);
      } else {
        console.log(`   ✅ ${name}`);
      }
    });

    console.groupEnd();
  }

  /** Safe localStorage JSON reader used by the debug block. */
  private _tryReadLs(key: string): any {
    const raw = localStorage.getItem(key);
    if (raw === null) return null;
    try { return JSON.parse(raw); } catch { return raw; }
  }

  /**
 * Método para construir el payload de actualización para un solo trayecto
 *
 * Genera un objeto con la estructura necesaria para actualizar productos relacionados a un solo trayecto
 * en el sistema, tomando datos del objeto `item` y `payload` recibidos.
 *
 * @param item -> objeto que contiene la información del producto y traslado
 * @param payload -> objeto con datos adicionales para construir el payload
 * @returns objeto con la estructura del payload para actualización
 */

  _payloadUpdate(item: any, payload: any): Object {

    return {
      products: [{
        bookingCode: item.bookParam,
        providerId: item.providerId,
        nameAdapter: null, // pedir el nameAdapter
        categoryId: item.payload[0].categoriesId[0],
        productId: item.idProduct,
        productName: item.vehicle.name,
        origin: item.payload[0].transfers.pickupLocation.origin ,
        destination: item.payload[0].transfers.dropoffLocation.destination,
        priceFrom: 0,
        priceTo: 10000.00,
        arrivalDate: item.payload[0].arrivalDate,
        departureDate: item.payload[0].departureDate,
        qtyProduct: 1,
        qtyPax: 0,
        others: {
          transfers: {
            paxList: item.payload[0].transfers.paxList
          }
        }
      }]
    };
  }

  /**
 * Método para construir el payload de actualización para trayecto ida y vuelta (two way)
 *
 * Similar a `_payloadUpdate`, pero se utiliza para actualizar productos que corresponden a traslados
 * de ida y vuelta, manteniendo la estructura requerida.
 *
 * @param item -> objeto que contiene la información del producto y traslado
 * @param payload -> objeto con datos adicionales para construir el payload
 * @returns objeto con la estructura del payload para actualización de dos trayectos
 */

  _payloadUpdateTwoWay(item: any, payload: any): Object {

    return {
      products: [{
        bookingCode: item.bookParam,
        providerId: item.providerId,
        nameAdapter: null, // pedir el nameAdapter
        categoryId: item.payload[0].categoriesId[0],
        productId: item.idProduct,
        productName: item.vehicle.name,
        origin: item.payload[0].transfers.pickupLocation.origin,
        destination: item.payload[0].transfers.dropoffLocation.destination,
        priceFrom: 0,
        priceTo: 10000.00,
        arrivalDate: item.payload[0].arrivalDate,
        departureDate: item.payload[0].departureDate,
        qtyProduct: 1,
        qtyPax: 0,
        others: {
          transfers: {
            paxList: item.payload[0].transfers.paxList
          }
        }
      }]
    };
  }


  /**
 * Método para agregar un ítem al itinerario según el tipo de trayecto (firstWay, noFirstWay, totalWay)
 *
 * Valida que el owner esté definido antes de agregar. Configura y asigna múltiples propiedades del ítem
 * según el tipo de trayecto, sincroniza payloads, calcula precios y atributos relacionados, y luego envía
 * el ítem al servicio de itinerario para su almacenamiento.
 *
 * @param item -> objeto que representa el ítem o producto a agregar al itinerario
 * @param result -> objeto con datos resultantes o adicionales para el ítem
 * @param typeWay -> cadena que indica el tipo de trayecto ('firstWay', 'noFirstWay', 'totalWay')
 */

  /**
   * Resolve the effective pickup datetime string for the current vehicle.
   *
   * The modal historically relied on `this.form.firstArrivalDate`, which the
   * parent (search-box) leaves as `null` when the user is doing a
   * ride-hailing search ("viaje ahora"). In that case the backend still
   * returns the actual service time on `item.timing.entry.entryDepartureDatetime`
   * (e.g. `"2026-06-15 17:17"`), so we fall back to that before giving up.
   *
   * Returns the raw string (`"YYYY-MM-DD HH:mm"` or ISO with `T`) so callers
   * can pick the slice they need. Returns `null` if nothing usable is found.
   */
  private resolvePickupDateTime(item: any): string | null {
    const fromForm = this.form?.firstArrivalDate;
    if (fromForm) return String(fromForm);
    const fromItem = item?.timing?.entry?.entryDepartureDatetime;
    if (fromItem) return String(fromItem);
    return null;
  }

  /**
   * Extract the date portion (YYYY-MM-DD) from a datetime string, accepting
   * both `"YYYY-MM-DD HH:mm"` and ISO `"YYYY-MM-DDT..."` formats. Returns
   * `null` for any falsy / malformed input.
   */
  private toDateOnly(value: string | null | undefined): string | null {
    if (!value) return null;
    const idxSpace = value.indexOf(' ');
    const idxT = value.indexOf('T');
    let cut: number;
    if (idxSpace === -1 && idxT === -1) {
      cut = -1;
    } else if (idxSpace === -1) {
      cut = idxT;
    } else if (idxT === -1) {
      cut = idxSpace;
    } else {
      cut = Math.min(idxSpace, idxT);
    }
    const date = cut === -1 ? value : value.substring(0, cut);
    return /^\d{4}-\d{2}-\d{2}$/.test(date) ? date : null;
  }

  addToItinerary(item: any, result: any, typeWay: string) {

    // ============================================================
    // DEBUG: trace the addToItinerary flow to find the next crash.
    // Open the browser console, fire the modal in ride-hailing mode,
    // click "agregar" and watch this output to see exactly where it
    // fails. Remove once the modal is verified working.
    // ============================================================
    console.groupCollapsed(
      `%c[modal-transports]%c addToItinerary @ ${new Date().toISOString()}`,
      'background:#FF3F63;color:#fff;font-weight:bold;padding:2px 6px;border-radius:3px',
      'color:inherit'
    );
    console.log('typeWay:', typeWay);
    console.log('item.timing?.entry?.entryDepartureDatetime:', item?.timing?.entry?.entryDepartureDatetime);
    console.log('item.timing?.return?.returnDepartureDatetime:', item?.timing?.return?.returnDepartureDatetime);
    console.log('this.form?.firstArrivalDate:', this.form?.firstArrivalDate);
    console.log('this.form?.firstOrigin:', this.form?.firstOrigin);
    console.log('item.vehicle?.maxPax:', item?.vehicle?.maxPax);
    console.log('item.vehicle?.code:', item?.vehicle?.code);
    console.log('item.pricing?.currency:', item?.pricing?.currency);
    console.log('item.profilityEntry?.netPrice:', item?.profilityEntry?.netPrice);
    console.log('item.profilityEntry?.netPriceBooking:', item?.profilityEntry?.netPriceBooking);
    console.log('item.timing?.entry?.entryCancellationPolicies:', item?.timing?.entry?.entryCancellationPolicies);
    console.groupEnd();

    // validar si owner esta lleno
    if ( !isValidOwener(this._cookieService.get('clientActive'))){
      //this.toastr.warning(fillOwnerMessage());
      return;
    }

    item.categoryName = this.origin;
    // item.form = this.form !== undefined ? this.form.value : undefined,
    // item.payload =  this.__payloadForm, // this.payload,

    let payload = JSON.parse(localStorage.getItem('payload'));
    const transport_assignment = JSON.parse(localStorage.getItem('transport_assignment'));

    if(this.arrayResults && this.arrayResults.length > 0 && this.arrayResults[0].component) {

      if(this.arrayResults[0].component === 'suggestion_itinerary') {
        payload = [this.payload];
        // transport_assignment.selectedVehicles.push(item);
      }
    }

    if((transport_assignment && transport_assignment.selectedVehicles.length > 0) || (this.arrayResults && this.arrayResults.length > 0 && this.arrayResults[0].component && this.arrayResults[0].component === 'suggestion_itinerary')) {
      payload[0].transfers.paxList = {
        adults: transport_assignment ? transport_assignment.selectedVehicles[transport_assignment.selectedVehicles.length - 1]?.adults : payload[0].transfers.paxList?.adults,
        children: transport_assignment ? transport_assignment.selectedVehicles[transport_assignment.selectedVehicles.length - 1]?.childrenAges : payload[0].transfers.paxList?.children
      }
      this.form.firstqtyAdults = transport_assignment ? transport_assignment.selectedVehicles[transport_assignment.selectedVehicles.length - 1]?.adults : payload[0].transfers.paxList?.adults;
      this.form.firstqtyChilds = transport_assignment ? transport_assignment.selectedVehicles[transport_assignment.selectedVehicles.length - 1]?.childrenAges : payload[0].transfers.paxList?.children;
    } else {
      return;
    }

    // Resolve the effective pickup datetime once, up front, so every branch
    // below (firstWay, noFirstWay, totalWay) can use the same value without
    // re-implementing the fallback. For ride-hailing flows `form.firstArrivalDate`
    // is null and the only place the time is available is on `item.timing`.
    const pickupDateTime = this.resolvePickupDateTime(item);
    const arrivalDate = this.toDateOnly(pickupDateTime);

    let returnPayload: any;
    let returnForm: any;
    // Only enter the round-trip branch when the user actually selected a
    // two-way transfer AND the parent search-box populated the
    // returnTransfer{Payload,Form} keys. For ride-hailing / one-way
    // searches those keys are not set, so we skip this block entirely.
    if(!payload[0].transfers.oneWay
        && localStorage.getItem('returnTransferPayload')
        && localStorage.getItem('returnTransferForm')) {
      returnPayload = JSON.parse(localStorage.getItem('returnTransferPayload'));
      returnForm = JSON.parse(localStorage.getItem('returnTransferForm'));
       returnPayload[0].transfers.paxList = {
        adults: transport_assignment.selectedVehicles[transport_assignment.selectedVehicles.length - 1]?.adults,
        children: transport_assignment.selectedVehicles[transport_assignment.selectedVehicles.length - 1]?.childrenAges
      }
      returnForm.firstqtyAdults = transport_assignment.selectedVehicles[transport_assignment.selectedVehicles.length - 1]?.adults;
      returnForm.firstqtyChilds = transport_assignment.selectedVehicles[transport_assignment.selectedVehicles.length - 1]?.childrenAges;
    }

    item.id = item.id;
    item.providerId = item.providerId;
    item.idProduct = item.productId;
    item.nameAdapter = result.nameAdapter;

switch(typeWay) {
  case 'firstWay':
    item.vehicleCode = item.vehicle ? item.vehicle.code : null;
    item.maxPax = item.vehicle ? item.vehicle.maxPax : null;
    item.payload = payload ?? null;
    item.origin = this.form?.firstOrigin ?? null;
    item.destination = this._itineraryService.getDestinationInfo?.(this.form, item) ?? null;
    item.arrivalDate = arrivalDate;
    item.departureDate = arrivalDate;
    item.formTransport = this.formTransport ?? null;
    item.productKey = this.getRandomUniqueId?.() ?? null;
    item.payloadUpdate = this._payloadUpdate?.(item, payload) ?? null;
    item.payloadSync = this.payloadSync(item, payload, typeWay);
    item.tax = item.tax ?? null;
    item.profility = item.profilityEntry ?? null;
    item.profility.netPriceBooking = item.netPriceBookingWithIncluded / 2 || item.profilityEntry.netPriceBooking / 2 / 2;
    item.profility.netPriceAgent = item.netPriceBookingWithIncluded / 2 || item.profilityEntry.netPriceAgent / 2 / 2;
    item.profilityEntry.netPriceBooking = item.netPriceBookingWithIncluded / 2 || item.profilityEntry.netPriceBooking / 2 / 2;
    item.profilityEntry.netPriceAgent = item.netPriceBookingWithIncluded / 2 || item.profilityEntry.netPriceAgent / 2 / 2;

    // ✅ CALCULAR TOTAL DE ADICIONALES
    let totalAddonsFirstWay = 0;
    (item.amenitiesIncluded || []).forEach((addon: any) => {
      totalAddonsFirstWay += addon.totalPrice || addon.priceProf || addon.price || 0;
    });
    (item.addonsIncluded || []).forEach((addon: any) => {
      totalAddonsFirstWay += addon.totalPriceProf || addon.totalAmount || addon.price || 0;
    });

    // ✅ SUMAR ADICIONALES A PROFILITY
    if (totalAddonsFirstWay > 0) {
      // Sumar a profility principal
      item.profility.netPrice = (item.profility.netPrice || 0) + totalAddonsFirstWay;
      item.profility.netPriceCategory = (item.profility.netPriceCategory || 0) + totalAddonsFirstWay;
      item.profility.netPriceProvider = (item.profility.netPriceProvider || 0) + totalAddonsFirstWay;
      item.profility.netPriceBooking = (item.profility.netPriceBooking || 0) + totalAddonsFirstWay;
      item.profility.netPriceAgent = (item.profility.netPriceAgent || 0) + totalAddonsFirstWay;
      item.profility.blickoins = (item.profility.blickoins || 0) + (totalAddonsFirstWay * 0.2);
      item.profility.creditBlickoins = (item.profility.creditBlickoins || 0) + (totalAddonsFirstWay * 0.02);

      // Sumar a profilityEntry
      item.profilityEntry.netPrice = (item.profilityEntry.netPrice || 0) + totalAddonsFirstWay;
      item.profilityEntry.netPriceCategory = (item.profilityEntry.netPriceCategory || 0) + totalAddonsFirstWay;
      item.profilityEntry.netPriceProvider = (item.profilityEntry.netPriceProvider || 0) + totalAddonsFirstWay;
      item.profilityEntry.netPriceBooking = (item.profilityEntry.netPriceBooking || 0) + totalAddonsFirstWay;
      item.profilityEntry.netPriceAgent = (item.profilityEntry.netPriceAgent || 0) + totalAddonsFirstWay;
      item.profilityEntry.blickoins = (item.profilityEntry.blickoins || 0) + (totalAddonsFirstWay * 0.2);
      item.profilityEntry.creditBlickoins = (item.profilityEntry.creditBlickoins || 0) + (totalAddonsFirstWay * 0.02);
    }

    item.priceUnitary = item.profilityEntry?.netPrice ?? null;
    item.netPriceFreeTax = item.profilityEntry?.netPrice ?? null;
    item.totalPriceFreeTax = item.profilityEntry?.netPriceBooking ?? null;
    item.totalPriceProf = item.profilityEntry?.netPriceBooking ?? null;
    item.netPriceProf = item.profilityEntry?.netPriceBooking ?? null;
    item.netPriceBookingWithIncluded = item.netPriceBookingWithIncluded ? item.netPriceBookingWithIncluded / 2 : null;
    item.amount = item.profilityEntry?.netPriceBooking ?? null;
    item.priceWithoutTax = item.pricing?.priceWithoutTax ?? null;
    item.totalPrice = item.pricing?.totalPrice ?? null;
    item.blickoins = item.profilityEntry?.blickoins ?? null;
    item.creditBlickoins = item.profilityEntry?.creditBlickoins ?? null;
    item.cancellationPolicies = item?.timing?.entry?.entryCancellationPolicies || [];
    item.expiration_date = item?.timing?.entry?.entryCancellationPolicies?.length > 0
      ? this.adjustDate(item?.timing?.entry?.entryCancellationPolicies[0]?.from, -1) ?? payload?.pickupDate
      : null;
    item.firstWay = 1;
    break;

  case 'noFirstWay':
    item.payloadSync = undefined;
    item.vehicleCode = item.vehicle?.code ?? null;
    item.maxPax = item.vehicle?.maxPax ?? null;
    item.payload = returnPayload ?? null;
    item.origin = returnForm[0].firstOrigin ?? null;
    item.destination = this._itineraryService.getDestinationInfo?.(returnForm[0], item) ?? null;
    item.arrivalDate = returnForm[0]?.firstArrivalDate.split('T')[0] ?? null;
    item.departureDate = returnForm[0]?.firstArrivalDate.split('T')[0] ?? null;
    item.formTransport = returnForm[0] ?? null;
    item.productKey = this.getRandomUniqueId?.() ?? null;
    item.payloadUpdate = this._payloadUpdateTwoWay?.(item, payload) ?? null;
    item.payloadSync = this.payloadSync(item, payload, typeWay);
    item.tax = item.tax ?? null;
    item.profility = item.profilityReturn ?? null;
    item.profility.netPriceBooking = item.netPriceBookingWithIncluded || item.profilityReturn.netPriceBooking / 2;
    item.profility.netPriceAgent = item.netPriceBookingWithIncluded || item.profilityReturn.netPriceAgent / 2;
    item.profilityReturn.netPriceBooking = item.netPriceBookingWithIncluded || item.profilityReturn.netPriceBooking / 2;
    item.profilityReturn.netPriceAgent = item.netPriceBookingWithIncluded || item.profilityReturn.netPriceAgent / 2;

    // ✅ CALCULAR TOTAL DE ADICIONALES
    let totalAddonsNoFirstWay = 0;
    (item.amenitiesIncluded || []).forEach((addon: any) => {
      totalAddonsNoFirstWay += addon.totalPrice || addon.priceProf || addon.price || 0;
    });
    (item.addonsIncluded || []).forEach((addon: any) => {
      totalAddonsNoFirstWay += addon.totalPriceProf || addon.totalAmount || addon.price || 0;
    });

    // ✅ SUMAR ADICIONALES A PROFILITY
    if (totalAddonsNoFirstWay > 0) {
      // Sumar a profility principal
      item.profility.netPrice = (item.profility.netPrice || 0) + totalAddonsNoFirstWay;
      item.profility.netPriceCategory = (item.profility.netPriceCategory || 0) + totalAddonsNoFirstWay;
      item.profility.netPriceProvider = (item.profility.netPriceProvider || 0) + totalAddonsNoFirstWay;
      item.profility.netPriceBooking = (item.profility.netPriceBooking || 0) + totalAddonsNoFirstWay;
      item.profility.netPriceAgent = (item.profility.netPriceAgent || 0) + totalAddonsNoFirstWay;
      item.profility.blickoins = (item.profility.blickoins || 0) + (totalAddonsNoFirstWay * 0.2);
      item.profility.creditBlickoins = (item.profility.creditBlickoins || 0) + (totalAddonsNoFirstWay * 0.02);

      // Sumar a profilityReturn
      item.profilityReturn.netPrice = (item.profilityReturn.netPrice || 0) + totalAddonsNoFirstWay;
      item.profilityReturn.netPriceCategory = (item.profilityReturn.netPriceCategory || 0) + totalAddonsNoFirstWay;
      item.profilityReturn.netPriceProvider = (item.profilityReturn.netPriceProvider || 0) + totalAddonsNoFirstWay;
      item.profilityReturn.netPriceBooking = (item.profilityReturn.netPriceBooking || 0) + totalAddonsNoFirstWay;
      item.profilityReturn.netPriceAgent = (item.profilityReturn.netPriceAgent || 0) + totalAddonsNoFirstWay;
      item.profilityReturn.blickoins = (item.profilityReturn.blickoins || 0) + (totalAddonsNoFirstWay * 0.2);
      item.profilityReturn.creditBlickoins = (item.profilityReturn.creditBlickoins || 0) + (totalAddonsNoFirstWay * 0.02);
    }

    item.priceUnitary = item.profilityReturn?.netPrice ?? null;
    item.netPriceFreeTax = item.profilityReturn?.netPrice ?? null;
    item.totalPriceFreeTax = item.profilityReturn?.netPriceBooking ?? null;
    item.totalPriceProf = item.profilityReturn?.netPriceBooking ?? null;
    item.netPriceProf = item.profilityReturn?.netPriceBooking ?? null;
    item.netPriceBookingWithIncluded = item.netPriceBookingWithIncluded ? item.netPriceBookingWithIncluded : null;
    item.amount = item.profilityReturn?.netPriceBooking ?? null;
    item.priceWithoutTax = item.pricing?.priceWithoutTax ?? null;
    item.totalPrice = item.pricing?.totalPrice ?? null;
    item.blickoins = item.profilityReturn?.blickoins ?? null;
    item.creditBlickoins = item.profilityReturn?.creditBlickoins ?? null;
    item.cancellationPolicies = item?.timing?.return?.returnCancellationPolicies || [];
    item.expiration_date = item?.timing?.return?.returnCancellationPolicies?.length > 0
      ? this.adjustDate(item?.timing?.return?.returnCancellationPolicies[0]?.from, -1) ?? returnPayload?.pickupDate
      : null;
    item.firstWay = 2;
    break;

  case 'totalWay':
    if (!payload[0].transfers.oneWay && !this.selectedOneVehicleDoubleWay) {
      const val = this._userService.numberNoCloneOneWay;

      item.wayNoCloneVehicleDoubleWay = val === 0 ? 1 : val === 1 ? 2 : 1;
      this._userService.numberNoCloneOneWay = item.wayNoCloneVehicleDoubleWay;
      item.vehicleCode = item.vehicle?.code ?? null;
      item.maxPax = item.vehicle?.maxPax ?? null;

      if (this._userService.numberNoCloneOneWay === 1) {
        item.payload = payload ?? null;
        item.origin = this.form?.firstOrigin ?? null;
        item.destination = this._itineraryService?.getDestinationInfo?.(this.form, item) ?? null;
        item.arrivalDate = item.timing.entry['entryDepartureDatetime'].split('T')[0] ?? null;
        item.departureDate = item.timing.entry['entryDepartureDatetime'].split('T')[0] ?? null;
        item.formTransport = this.formTransport ?? null;
        item.expiration_date = item?.timing?.entry?.entryCancellationPolicies?.length > 0
          ? item?.timing?.entry?.entryCancellationPolicies[0]?.from ?? payload?.pickupDate
          : null;
        item.noCloneFirstWay = 1;
        this._userService.numberNoCloneOneWay = 2;
      } else if (this._userService.numberNoCloneOneWay === 2) {
        item.payload = returnPayload ?? null;
        item.origin = returnForm[0].firstOrigin ?? null;
        item.destination = this._itineraryService.getDestinationInfo?.(returnForm[0], item) ?? null;
        item.arrivalDate = returnForm[0]?.firstArrivalDate.split('T')[0] ?? null;
        item.departureDate = returnForm[0]?.firstArrivalDate.split('T')[0] ?? null;
        item.formTransport = returnForm[0] ?? null;
        item.expiration_date = item?.timing?.entry?.entryCancellationPolicies?.length > 0
          ? this.adjustDate(item?.timing?.entry?.entryCancellationPolicies[0]?.from, -1) ?? returnPayload?.pickupDate
          : null;
        item.noCloneFirstWay = 2;
        this._userService.numberNoCloneOneWay = 0;
      }

      item.productKey = this.getRandomUniqueId?.() ?? null;
      item.payloadUpdate = this._payloadUpdate?.(item, payload) ?? null;
      item.payloadSync = this.payloadSync(item, payload, typeWay);
      item.tax = item.tax ?? null;
      item.netPriceProf = item.netPriceBookingWithIncluded ?? null;
      item.amount = item.netPriceProf ?? null;
      item.totalPrice = item.pricing?.totalPrice ?? null;
      item.priceWithoutTax = item.pricing?.priceWithoutTax ?? null;
      item.blickoins = item.profility?.blickoins ?? null;
      item.creditBlickoins = item.profility?.creditBlickoins ?? null;
      item.cancellationPolicies = item?.timing?.entry?.entryCancellationPolicies || [];
      item.totalWay = 1;
    }

    if (payload[0].transfers.oneWay) {
      item.vehicleCode = item.vehicle?.code ?? null;
      item.maxPax = item.vehicle?.maxPax ?? null;
      item.payload = payload ?? null;
      item.origin = this.form?.firstOrigin ?? null;
      item.destination = this._itineraryService?.getDestinationInfo?.(this.form, item) ?? null;
      item.arrivalDate = item.timing.entry['entryDepartureDatetime'].split('T')[0] ?? null;
      item.departureDate = item.timing.entry['entryDepartureDatetime'].split('T')[0] ?? null;
      item.formTransport = this.formTransport ?? null;
      item.productKey = this.getRandomUniqueId?.() ?? null;
      item.payloadUpdate = this._payloadUpdate?.(item, payload) ?? null;
      item.payloadSync = this.payloadSync(item, payload, typeWay);
      item.tax = item.tax ?? null;

      // ✅ CALCULAR TOTAL DE ADICIONALES
      let totalAddonsTotalWay = 0;
      (item.amenitiesIncluded || []).forEach((addon: any) => {
        totalAddonsTotalWay += addon.totalPrice || addon.priceProf || addon.price || 0;
      });
      (item.addonsIncluded || []).forEach((addon: any) => {
        totalAddonsTotalWay += addon.totalPriceProf || addon.totalAmount || addon.price || 0;
      });

      // ✅ SUMAR ADICIONALES A PROFILITY
      item.profility.netPrice = (item.profility.netPrice || 0) + totalAddonsTotalWay;
      item.profility.netPriceCategory = (item.profility.netPriceCategory || 0) + totalAddonsTotalWay;
      item.profility.netPriceProvider = (item.profility.netPriceProvider || 0) + totalAddonsTotalWay;
      item.profility.netPriceBooking = (item.profility.netPriceBooking || 0) + totalAddonsTotalWay;
      item.profility.netPriceAgent = (item.profility.netPriceAgent || 0) + totalAddonsTotalWay;
      item.profility.blickoins = (item.profility.blickoins || 0) + (totalAddonsTotalWay * 0.2);
      item.profility.creditBlickoins = (item.profility.creditBlickoins || 0) + (totalAddonsTotalWay * 0.02);

      item.profilityEntry.netPrice = (item.profilityEntry.netPrice || 0) + totalAddonsTotalWay;
      item.profilityEntry.netPriceCategory = (item.profilityEntry.netPriceCategory || 0) + totalAddonsTotalWay;
      item.profilityEntry.netPriceProvider = (item.profilityEntry.netPriceProvider || 0) + totalAddonsTotalWay;
      item.profilityEntry.netPriceBooking = (item.profilityEntry.netPriceBooking || 0) + totalAddonsTotalWay;
      item.profilityEntry.netPriceAgent = (item.profilityEntry.netPriceAgent || 0) + totalAddonsTotalWay;
      item.profilityEntry.blickoins = (item.profilityEntry.blickoins || 0) + (totalAddonsTotalWay * 0.2);
      item.profilityEntry.creditBlickoins = (item.profilityEntry.creditBlickoins || 0) + (totalAddonsTotalWay * 0.02);

      item.netPriceProf = item.netPriceBookingWithIncluded ?? null;
      item.netPriceBookingWithIncluded = item.netPriceBookingWithIncluded ?? null;
      item.amount = item.netPriceProf ?? null;
      item.totalPrice = item.pricing?.totalPrice ?? null;
      item.priceWithoutTax = item.pricing?.priceWithoutTax ?? null;
      item.blickoins = item.profility?.blickoins ?? null;
      item.creditBlickoins = item.profility?.creditBlickoins ?? null;
      item.cancellationPolicies = item?.timing?.entry?.entryCancellationPolicies || [];
      item.expiration_date = item?.timing?.entry?.entryCancellationPolicies?.length > 0
        ? this.adjustDate(item?.timing?.entry?.entryCancellationPolicies[0]?.from, -1) ?? payload?.pickupDate
        : null;
      item.totalWay = 1;
    }
    break;

  default:
    break;
}
    item.searchId = result?.searchId ?? null; // pasar el searchId
    item.updateDate = new Date();
    item.from = this.from;
    item.providerName = item?.providerName ?? null;
    item.title = item?.vehicle?.name ?? null;
    item.serviceResponse = null;
    item.transferId = result?.transferId ?? null; // ver esto
    item.cancellation_policy = item?.cancellationPolicies ?? null;

    item.expirationDate = result?.expirationDate ?? null; // ver esto
    item.bookParam = item?.bookingCode ?? null;
    item.bookingCode = item?.bookingCode ?? null;
    item.currency = item?.pricing?.currency ?? null;
    this.currencySelected = item?.currency ?? null;
    this._itineraryService.sendMessageSubscriptorLoading(true);

    if(this._userService.itineraryArrivalDateFull === null) {
       this._itineraryService.itinerary.arrivalDate = item.arrivalDate;
       this._itineraryService.itinerary.departureDate = item.departureDate;
    } else {
      if(moment(this._userService.itineraryArrivalDateFull) > moment(item.arrivalDate)) {
        this._itineraryService.itinerary.arrivalDate = item.arrivalDate;
      }
      if(moment(this._userService.itineraryDepartureDateFull) < moment(item.departureDate)) {
        this._itineraryService.itinerary.departureDate = item.departureDate;
      }
    }
    this._itineraryService.add(item).subscribe(
      (response:any) => {
        if (typeof response === 'string') {
          //this.toastr.error(response);
        } else {
          this._itineraryService.currencySuccessEmit.next(item.currency);
          //this.toastr.success('Product added successfully to your itinerary');
        }
        // this._itineraryService.sendMessageSubscriptorLoading(false);
        this._itineraryService.evaluateDateItineraryRange(this._itineraryService.itinerary["items"]);
      },
      error => {
        console.log('Product not added', error);
        this._itineraryService.sendMessageSubscriptorLoading(false);
        //this.toastr.error('An error occurred, product was not added', 'Error');
      }
    );
  }

  adjustDate(date: string | Date, days: number): string {
  if (!date) return '';

  // Convertir Date a string si es necesario
  let dateStr: string;
  if (typeof date === 'string') {
    dateStr = date;
  } else {
    // Asumiendo que es un objeto Date
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    dateStr = `${year}-${month}-${day}`;
  }

  const d = new Date(dateStr);
  d.setDate(d.getDate() + days);
  return d.toISOString().split('T')[0];
}

  /**
 * Método para sincronizar y construir el payload de un ítem de transporte según el tipo de trayecto
 *
 * Este método recibe un ítem, el payload original y el tipo de trayecto, y devuelve un objeto
 * con la estructura necesaria para sincronizar la información del traslado, incluyendo fechas,
 * información del vehículo, y lista de pasajeros.
 *
 * @param item -> objeto que contiene los datos del producto o traslado
 * @param payload -> arreglo con el payload original de la solicitud
 * @param typeWay -> string que indica el tipo de trayecto ('firstWay', 'noFirstWay', 'totalWay')
 * @returns objeto con los datos sincronizados para el traslado
 */

  payloadSync(item: any, payload: any, typeWay: string): any{

    return  {
      providerId: item.providerId,
      productId: item.productId,
      categoriesId: [8],
      pickupDate: item.timing?.entry?.entryDepartureDatetime,
      dropoffDate: item.timing?.return?.returnDepartureDatetime ? item.timing?.return?.returnDepartureDatetime : item.timing?.entry?.entryDepartureDatetime,
      market: payload[0].market, // Anteriormente el valor era de 2
      agencyId: this._userService._agencyID,
      id: item.id,
      transfers: {
        oneWay: typeWay !== 'totalWay' ? false : true,
        vehicleId: item.productId,
        vehicleCode: item.vehicle.code,
        bookingCode: item.bookingCode,
        paxList: payload[0].transfers.paxList
      }
    }
  }

  /**
 * Método para continuar con la selección del vehículo
 *
 * Este método maneja la lógica principal al continuar con la selección de un vehículo en un traslado.
 * Dependiendo de si el traslado es "oneWay" o no, agrega uno o dos tramos al itinerario y actualiza
 * la información del mismo, emitiendo eventos para el cierre del modal.
 *
 * @vehicle -> objeto con la información del vehículo seleccionado
 */

  continue(vehicle: any): void {
    this.transportService.assignVehicle(vehicle);
    let payload = JSON.parse(localStorage.getItem('payload'));

    if(this.arrayResults && this.arrayResults.length > 0 && this.arrayResults[0].component) {

      if(this.arrayResults[0].component === 'suggestion_itinerary') {
        payload = [this.payload];
      }
    }
    if(payload[0].transfers.oneWay || !this.selectedOneVehicleDoubleWay) {
      this._itineraryService.itinerary.clientId = this.clientSetting?.id;
      this.addToItinerary(vehicle, this.service, 'totalWay');
      this._emitRefModal('add');
      this._itineraryService.itinerary.currency = this.currencySelected;
      this._itineraryService.updateItinerary(this._itineraryService.itinerary);

      if(!this.selectedOneVehicleDoubleWay) {
        this._itineraryService.emitNoCloneVehicleDoubleWay();
      }

    } else {

      this.addToItinerary(vehicle, this.service, 'firstWay');
      this._itineraryService.itinerary.currency = this.currencySelected;
      this._itineraryService.itinerary.clientId = this.clientSetting?.id;
      this._itineraryService.updateItinerary(this._itineraryService.itinerary);
      if(this.payload.transfers.oneWay && !this.selectedOneVehicleDoubleWay) {
        this._emitRefModal('add');
        this._itineraryService.itinerary.currency = this.currencySelected;

      } else {

        setTimeout(() => {
          this.addToItinerary(vehicle, this.service, 'noFirstWay');
          this._emitRefModal('add');
          this._itineraryService.itinerary.currency = this.currencySelected;
          this._itineraryService.itinerary.clientId = this.clientSetting?.id;
          this._itineraryService.updateItinerary(this._itineraryService.itinerary);
        }, 500);

      }

    }

  }

  canSelectVehicle(vehicle: any): boolean {
    return this.transportService.canAssignVehicle(vehicle);
  }

  getAssignmentStatus(): void {
  const current = this.transportService.getRemainingPassengers();
}

  /**
 * Método para seleccionar una única unidad para ida y vuelta
 *
 * Almacena si se seleccionó una sola unidad para el viaje de ida y vuelta.
 *
 * @event -> valor booleano que indica si se seleccionó un solo vehículo para ambos tramos
 */

  selectOneVehicleDoubleWay(event: boolean): void {
    this.selectedOneVehicleDoubleWay = event;
  }

  /**
 * Método para generar un ID único aleatorio
 *
 * Genera un identificador numérico único basado en un número aleatorio y la marca de tiempo actual.
 *
 * @returns número único aleatorio
 */

  getRandomUniqueId(){
    return Math.floor(Math.random() * 20000000000000) + Date.now();
  }

  /**
 * Método para emitir el cierre del modal
 *
 * Emite un evento con valor `'pers'` a través de `refModal` para indicar que el modal debe cerrarse o actualizarse.
 */

  _emitRefModal(event: string) {
    this.refModal.emit(event);
  }

    /**
 * Extrae el nombre del transporte según el tipo y el formulario recibido
 *
 * @param form -> objeto con datos del transporte
 * @param type -> cadena que indica si es 'origin' o 'destination'
 * @returns string -> nombre del transporte formateado según tipo y datos
 */
  extractNameTransport(form: any, type: string): string {

    if(form) {
      switch(type) {
        case 'origin':
          switch(this.payload.transfers.pickupLocation.type) {
            case 'hotel':
              return form.name;
            case 'airport':
              return `${form.name} (${form.iata})`;
            case 'destination':
              return form.city_name;
          }
        case 'destination':
          switch(this.payload.transfers.dropoffLocation.type) {
            case 'hotel':
              return form.name;
            case 'airport':
              return `${form.name} (${form.iata})`;
            case 'destination':
              return form.city_name;
          }
      }
    }

  }

      getPayloadOneWay(): boolean {
        // console.log(this.payload)
      return this.payload[0]?.transfer?.oneWay;
    }


  close() {
    this._emitRefModal('close');
  }
}
